import React from 'react';
import PropTypes from 'prop-types';

// styles used by the others components.
import {
  QuestionLabel,
  Container,
} from '../styles';

// styles local
import {
  MatrixTableContainer,
  TableWrapper,
  TableRow,
  TableCell,
  RadioBox,
} from './styles';

const ParticipantMatrixQuestion = (props) => {
  const {
    label,
    index,
    optionAnswers,
    questionOptions,
    matrixType,
  } = props;

  const rows = questionOptions.filter((option) => option.matrixOption === 'row');
  const columns = questionOptions.filter((option) => option.matrixOption === 'column');
  const answersParsed = JSON.parse(optionAnswers);
  const matrixTypeTitle = matrixType === 'single_select' ? 'Single Select' : 'Multiple Select';
  return (
    <Container>
      <QuestionLabel>{`Question ${index + 1}: ${label} (Matrix ${matrixTypeTitle})`}</QuestionLabel>
      <MatrixTableContainer>
        <TableWrapper>
          <TableRow>
            <TableCell />
            {columns.map((column) => (
              <TableCell title={column.label} key={column.label}>{column.label}</TableCell>
            ))}
          </TableRow>
          {rows.map((row) => (
            <TableRow key={row.id}>
              <TableCell row={+true} title={row.label}>{row.label}</TableCell>
              {columns.map((column) => (
                <TableCell key={`${row.id}-${column.id}`}>
                  {
                    matrixType === 'single_select' && (
                      <RadioBox
                        data-matrix-single-checked={answersParsed[row.id] === column.id || answersParsed[row.id] === column.id}
                        data-matrix-type="single_select"
                        radio
                        checked={answersParsed[row.id] === column.id || answersParsed[row.id] === column.id}
                        readOnly
                      />
                    )
                  }
                  {
                    matrixType === 'multiple_select' && (
                      <RadioBox
                        data-matrix-multiple-checked={answersParsed[row.id]?.includes(column.id)}
                        data-matrix-type="multiple_select"
                        checkbox
                        checked={answersParsed[row.id]?.includes(column.id)}
                        readOnly
                      />
                    )
                  }
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableWrapper>
      </MatrixTableContainer>
    </Container>
  );
};

ParticipantMatrixQuestion.propTypes = {
  label: PropTypes.string.isRequired,
  questionOptions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    id: PropTypes.string,
  })).isRequired,
  index: PropTypes.number,
  optionAnswers: PropTypes.instanceOf(Array),
  matrixType: PropTypes.string.isRequired,
};

ParticipantMatrixQuestion.defaultProps = {
  index: null,
  optionAnswers: [],
};

export default ParticipantMatrixQuestion;
